import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {必須入力, 日付書式} from '@/type/validation/validator';
import moment from 'moment';
import {払出修正候補編集レコード型} from '@/type/withdrawal/records/modify/払出修正候補編集レコード型';

export default class 払出修正候補編集入力チェッカー {
  単項目チェック結果: Error[] = [];
  相関チェック結果: Error[] = [];

  constructor() {
    this.単項目チェック結果 = [];
    this.相関チェック結果 = [];
  }

  validate(target: 払出修正候補編集レコード型, バラ管理である: boolean) {
    if (バラ管理である) {
      const 単項目チェック = new ValidationResult(バラ管理単項目チェックValidators);
      単項目チェック.validate(target);
      this.単項目チェック結果 = 単項目チェック.getErrors;
      const 有効期限切れエラー = 単一行有効期限切れ(target);
      const 払出数エラー = 単一行払出箱数か払出バラ数がゼロ以外(target);
      this.相関チェック結果 = 有効期限切れエラー.concat(払出数エラー);
    } else {
      const 単項目チェック = new ValidationResult(単項目チェックvalidators);
      単項目チェック.validate(target);
      this.単項目チェック結果 = 単項目チェック.getErrors;
      this.相関チェック結果 = 単一行有効期限切れ(target);
    }
  }

  validateList(target: 払出修正候補編集レコード型[], バラ管理である: boolean) {
    if (バラ管理である) {
      const 単項目チェック = new ValidationResult(バラ管理単項目チェックValidators);
      単項目チェック.validateList(target);
      this.単項目チェック結果 = 単項目チェック.getErrors;
      const 有効期限切れエラー = 有効期限切れ(target);
      const 払出数エラー = 払出箱数か払出バラ数がゼロ以外(target);
      this.相関チェック結果 = 有効期限切れエラー.concat(払出数エラー);
    } else {
      const 単項目チェック = new ValidationResult(単項目チェックvalidators);
      単項目チェック.validateList(target);
      this.単項目チェック結果 = 単項目チェック.getErrors;
      this.相関チェック結果 = 有効期限切れ(target);
    }
  }

  hasError(name: string, index: number = 0): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === index));
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  errorMessages(): string[] {
      const errorMEssages = this.単項目チェック結果.concat(this.相関チェック結果)
        .sort((a, b) => a.index - b.index)
        .map((value) => `${value.message}`);
      return Array.from(new Set(errorMEssages));
  }
}
const 払出年月日Validator: Validator = {
  name: '払出日',
  constraints: [
    {method: 必須入力, message: '払出年月日は入力が必須です'},
    {method: 日付書式, message: '払出年月日の書式を正しく入力してください'},
  ],
};

const 払出箱数Validator: Validator = {
  name: '払出箱数',
  constraints: [
    {method: 必須入力, message: '払出数は入力が必須です'},
    {method: ゼロより大, message: '払出数は0より大きな値にして下さい'},
  ],
};

const 単項目チェックvalidators: Validator[] = [払出箱数Validator, 払出年月日Validator];

const バラ管理単項目チェックValidators: Validator[] = [払出年月日Validator];

function ゼロより大(value: number): boolean {
  return value > 0;
}

function 有効期限切れ(target: 払出修正候補編集レコード型[]): Error[] {
  let errors: Error[] = [];
  target.forEach((value, index): void => {
    errors = errors.concat(単一行有効期限切れ(value, index));
  });
  return errors;
}

function 単一行有効期限切れ(value: 払出修正候補編集レコード型, index: number = 0): Error[] {
  const errors: Error[] = [];
  if (value.元レコード.払出有効期限 && moment(value.元レコード.払出有効期限) < moment(value.払出日)) {
    errors.push({index, message: '有効期限切れの商品を払い出すことはできません', constraint: '', name: '有効期限切れエラー'});
  }
  return errors;
}

function 払出箱数か払出バラ数がゼロ以外(target: 払出修正候補編集レコード型[]): Error[] {
  let errors: Error[] = [];
  target.forEach((value, index): void => {
    errors = errors.concat(単一行払出箱数か払出バラ数がゼロ以外(value, index));
  });
  return errors;
}

function 単一行払出箱数か払出バラ数がゼロ以外(value: 払出修正候補編集レコード型, index: number = 0): Error[] {
  const errors: Error[] = [];
  if (!ゼロより大(value.払出バラ数) && !ゼロより大(value.払出箱数)) {
    errors.push({index, message: '払出数(箱)または払出数(バラ)は0より大きな値にして下さい', constraint: '', name: '払出数エラー'});
  }
  return errors;
}
